// @flow
import React, { Fragment, useEffect } from "react";
import Spinner from "../spinner";
import { bindActionCreators } from "redux";
import * as sessionActionCreators from "../../action-creators/session-actions";
import * as modalActionCreators from "../../action-creators/modal-actions";
import { connect } from "react-redux";


type PropsType = { actions: { [string]: any => void }, children: ?any, isAuthenticated: boolean, isInitialized: boolean };


const MyComponentX = ({ actions, isInitialized, children }: PropsType): React$Element<any> => {

    useEffect(() => {
        if (!isInitialized) {
            actions.initialize();
        }
    }, []);

    return isInitialized
        ? <Fragment>{children}</Fragment>
        : <div style={{ position: "absolute", zIndex: 2000, height: "100vh", width: "100vw" }}><Spinner message="loading" /></div>;

};

const mapStateToProps = (state: Object): Object => {
    const isAuthenticated = state.session.isAuthenticated;
    const isInitialized = state.session.isInitialized;
    return { isAuthenticated, isInitialized };
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...sessionActionCreators, ...modalActionCreators }, dispatch)
});

const IsNotAuthed = ({ isAuthenticated, children }: PropsType) => (!isAuthenticated ? (<Fragment>{children}</Fragment>) : null);
const IsAuthed = ({ isAuthenticated, children }: PropsType) => (isAuthenticated ? (<Fragment>{children}</Fragment>) : null);

export const Session = connect(mapStateToProps, mapDispatchToProps)(MyComponentX);
export const IsNotAuthenticated = connect(mapStateToProps, mapDispatchToProps)(IsNotAuthed);
export const IsAuthenticated = connect(mapStateToProps, mapDispatchToProps)(IsAuthed);


